import React, { useState, useEffect, useRef } from 'react';

import SearchCustomer from '@components/common/biz/SearchCustomer';

import SatModal from '@components/common/satUI/SatModal';
import SatInput from '@components/common/satUI/SatInput';
import SatButton from '@components/common/satUI/SatButton';
import SatDataGrid from '@components/common/satUI/SatDataGrid';
import { useSelector } from 'react-redux';
import { checkOptionalRider } from '@common/utils';
import SatSelect from '@components/common/satUI/SatSelect';

const DeathBeneficiary = React.memo(
  ({
    virtlPlanYn,
    deathBeneficiaryList,
    handleSearchRelationList,
    handleChangeShareRate,
    handleDeleteBeneficiary,
    handleChangeSplitPayInfo,
    isDiv = false,
    isFnb = false,
  }) => {
    const [rateRefList] = useState([useRef(), useRef(), useRef()]);

    // hanjy: 사망시 수익자 비율 수정시 입력된 전체 항목에 대해 valid check
    const rateValidCheck = () => {
      rateRefList.forEach(rateRef => {
        rateRef.current?.isValidCheck();
      });
    };

    useEffect(() => {
      rateValidCheck();
    }, [deathBeneficiaryList]);

    useEffect(() => {
      if(deathBeneficiaryList.length !== 0) {
        if(isFnb) {
          if(deathBeneficiaryList[0].relatedProspectCustomerName === '법정상속인') {
            handleDeleteBeneficiary('death',  0);
          } 
        } else {
          handleDeleteBeneficiary('death',  0);
        }
      }
    }, [isFnb]);

    const columns = [
      {
        title: '사망시 수익자',
        dataIndex: 'index',
        key: 'index',
        width: '1.7rem',
        render: (value, row) => (
          <span className="list-num">{row.rowIndex + 1}.</span>
        ),
        headerColSpan: 2,
      },
      {
        title: '',
        dataIndex: 'relatedProspectCustomerName',
        key: 'relatedProspectCustomerName',
        width: isDiv ? '25%' : '50%',
        render: (value, row) => (
          <SatInput
            value={value}
            readOnly={
              virtlPlanYn === 'Y' ||
              (row.rowIndex === 2 &&
                deathBeneficiaryList[1].relatedProspectCustomerNo === '')
            }
            placeholder={'선택'}
            suffix={() => (
              <SatButton
                styleClass={`ico ico-search`}
                onClick={() => {
                  if (
                    !(
                      virtlPlanYn === 'Y' ||
                      (row.rowIndex === 2 &&
                        deathBeneficiaryList[1].relatedProspectCustomerNo ===
                          '')
                    )
                  ) {
                    handleSearchRelationList('death', row.rowIndex);
                  }
                }}
              />
            )}
            onClick={() => handleSearchRelationList('death', row.rowIndex)}
          />
        ),
      },
      {
        title: '',
        dataIndex: 'beneficiaryShareRate',
        key: 'beneficiaryShareRate',
        width: isDiv ? '25%' : '50%',
        setColumnStyle: 'pdl-20',
        render: (value, row) => (
          <div className="per">
            <SatInput
              type="number"
              value={String(value)}
              focusLabel={'사망 시 수익자 비중'}
              maxLength={3}
              onChange={value => handleChangeShareRate(value, row.rowIndex)}
              outerSuffix={() => <span className="txt">%</span>}
              validRule={
                value > 0
                  ? [
                      {
                        rule: () =>
                          deathBeneficiaryList
                            .map(item => item.beneficiaryShareRate)
                            .reduce((a, b) => Number(a) + Number(b), []) ===
                          100,
                        errMsg: '지급비율의 총 합은 100%로 입력해주세요.',
                      },
                    ]
                  : []
              }
              readOnly={virtlPlanYn === 'Y'}
              ref={rateRefList[row.rowIndex]}
            />
          </div>
        ),
      },
    ]
      .concat(
        isDiv
          ? [
              {
                title: '',
                dataIndex: 'splitPayRateCd',
                key: 'splitPayRateCd',
                width: '25%',
                setColumnStyle: 'pdl-20',
                render: (value, row) => (
                  <SatSelect
                    title="분할비율"
                    value={value}
                    onChange={value =>
                      handleChangeSplitPayInfo(
                        { splitPayRateCd: value.value },
                        row.rowIndex,
                      )
                    }
                    initOption={{ label: '', value: '' }}
                    options={[10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map(
                      value => ({
                        label: `${value}%`,
                        value,
                      }),
                    )}
                    readOnly={
                      virtlPlanYn === 'Y' ||
                      !isDiv ||
                      deathBeneficiaryList[row.rowIndex]
                        .relatedProspectCustomerNo <= 0 ||
                      row.adult !== false
                    }
                    ref={rateRefList[row.rowIndex]}
                  />
                ),
              },
              {
                title: '',
                dataIndex: 'splitPayEndAgeCd',
                key: 'splitPayEndAgeCd',
                width: '25%',
                setColumnStyle: 'pdl-20',
                render: (value, row) => (
                  <SatSelect
                    title="종료나이"
                    value={value}
                    onChange={value =>
                      handleChangeSplitPayInfo(
                        { splitPayEndAgeCd: value.value },
                        row.rowIndex,
                      )
                    }
                    initOption={{ label: '', value: '' }}
                    options={[20, 25, 30].map(value => ({
                      label: `만 ${value}세`,
                      value,
                    }))}
                    readOnly={
                      virtlPlanYn === 'Y' ||
                      !isDiv ||
                      deathBeneficiaryList[row.rowIndex]
                        .relatedProspectCustomerNo <= 0 ||
                      row.adult !== false
                    }
                    ref={rateRefList[row.rowIndex]}
                  />
                ),
              },
            ]
          : [],
      )
      .concat([
        {
          title: '',
          dataIndex: 'deleteButton',
          key: 'deleteButton',
          width: '2.2rem',
          render: (value, row) => (
            <SatButton
              styleClass={'txt-delete mgl-0'}
              label={'삭제'}
              disabled={
                row.relatedProspectCustomerNo === 0 || virtlPlanYn === 'Y'
              }
              onClick={() => {
                if (
                  row.relatedProspectCustomerNo !== 0 &&
                  virtlPlanYn !== 'Y'
                ) {
                  handleDeleteBeneficiary('death', row.rowIndex);
                }
              }}
            />
          ),
        },
      ]);
    return (
      <div className="box fst">
        <SatDataGrid columns={columns} dataSource={deathBeneficiaryList} />
      </div>
    );
  },
);
const MaturityBeneficiary = React.memo(
  ({
    maturityBeneficiary,
    virtlPlanYn,
    handleSearchRelationList,
    customerList,
    handleDeleteBeneficiary,
  }) => {
    const columns = [
      {
        title: '만기 생존시',
        dataIndex: 'relatedProspectCustomerName',
        key: 'relatedProspectCustomerName',
        width: '',
        render: value => (
          <SatInput
            value={value}
            readOnly={virtlPlanYn === 'Y'}
            suffix={() => (
              <SatButton
                styleClass={`ico ico-search`}
                onClick={() => {
                  if (virtlPlanYn !== 'Y') {
                    handleSearchRelationList('maturity');
                  }
                }}
              />
            )}
            onClick={() => handleSearchRelationList('maturity')}
          />
        ),
        headerColSpan: 2,
      },
      {
        title: '',
        dataIndex: 'deleteButton',
        key: 'deleteButton',
        width: '3.5rem',
        render: (value, row) => {
          const { custNo = '' } = customerList.find(customer =>
            ['ALL', 'Owner'].includes(customer.policyRelatedPersonCode),
          );

          return (
            <SatButton
              styleClass={'txt-delete'}
              label={'삭제'}
              disabled={
                custNo === row.relatedProspectCustomerNo || virtlPlanYn === 'Y'
              }
              onClick={() => {
                if (
                  custNo !== row.relatedProspectCustomerNo &&
                  virtlPlanYn !== ' Y'
                ) {
                  handleDeleteBeneficiary('maturity', row.rowIndex);
                }
              }}
            />
          );
        },
      },
    ];

    return (
      <div className="box">
        <SatDataGrid columns={columns} dataSource={[maturityBeneficiary]} />
      </div>
    );
  },
);

const InjuryBeneficiary = React.memo(
  ({
    injuryBeneficiary,
    virtlPlanYn,
    handleSearchRelationList,
    customerList,
    handleDeleteBeneficiary,
  }) => {
    const columns = [
      {
        title: '입원 상해시',
        dataIndex: 'relatedProspectCustomerName',
        key: 'relatedProspectCustomerName',
        width: '',
        render: value => (
          <SatInput
            value={value}
            readOnly={virtlPlanYn === 'Y'}
            suffix={() => (
              <SatButton
                styleClass={`ico ico-search`}
                onClick={() => {
                  if (virtlPlanYn !== 'Y') {
                    handleSearchRelationList('injury');
                  }
                }}
              />
            )}
            onClick={() => handleSearchRelationList('injury')}
          />
        ),
        headerColSpan: 2,
      },
      {
        title: '',
        dataIndex: 'deleteButton',
        key: 'deleteButton',
        width: '3.5rem',
        render: (value, row) => {
          const findCustomer = customerList.find(customer =>
            ['ALL', 'CoveredPerson'].includes(customer.policyRelatedPersonCode),
          );
          const custNo = findCustomer?.custNo || '';

          return (
            <SatButton
              styleClass={'txt-delete'}
              label={'삭제'}
              disabled={
                custNo === row.relatedProspectCustomerNo || virtlPlanYn === 'Y'
              }
              onClick={() => {
                if (
                  custNo !== row.relatedProspectCustomerNo &&
                  virtlPlanYn !== 'Y'
                ) {
                  handleDeleteBeneficiary('injury', row.rowIndex);
                }
              }}
            />
          );
        },
      },
    ];

    return (
      <div className="box">
        <SatDataGrid columns={columns} dataSource={[injuryBeneficiary]} />
      </div>
    );
  },
);

const DesignedDeputyPerson = React.memo(
  ({
    designedDeputyPerson,
    handleSearchRelationList,
    handleDeleteBeneficiary,
  }) => {
    const columns = [
      {
        title: '지정대리 청구인 ',
        dataIndex: 'index',
        key: 'index',
        width: '1.7rem',
        render: (value, row) => (
          <span className="list-num">{row.rowIndex + 1}.</span>
        ),
        headerColSpan: 3,
      },
      {
        title: '',
        dataIndex: 'relatedProspectCustomerName',
        key: 'relatedProspectCustomerName',
        width: '',
        render: (value, row) => (
          <SatInput
            value={value}
            readOnly={
              row.rowIndex === 1 &&
              designedDeputyPerson[0].relatedProspectCustomerNo === ''
            }
            placeholder={'선택'}
            suffix={() => (
              <SatButton
                styleClass={`ico ico-search`}
                onClick={() => {
                  if (
                    !(
                      row.rowIndex === 1 &&
                      designedDeputyPerson[0].relatedProspectCustomerNo === ''
                    )
                  ) {
                    handleSearchRelationList('deputy', row.rowIndex);
                  }
                }}
              />
            )}
            onClick={() => handleSearchRelationList('deputy', row.rowIndex)}
          />
        ),
      },
      {
        title: '',
        dataIndex: 'deleteButton',
        key: 'deleteButton',
        width: '3.5rem',
        render: (value, row) => (
          <SatButton
            styleClass={'txt-delete'}
            label={'삭제'}
            disabled={row.relatedProspectCustomerNo === ''}
            onClick={() => {
              if (row.relatedProspectCustomerNo !== '') {
                handleDeleteBeneficiary('deputy', row.rowIndex);
              }
            }}
          />
        ),
      },
    ];

    return (
      <div className={'box fst2'}>
        <SatDataGrid columns={columns} dataSource={designedDeputyPerson} />
      </div>
    );
  },
);

const ContractRelatePerson = props => {
  const {
    planEstablishRelatePerson,
    customerList,
    beneficiaryInfo,
    virtlPlanYn,
    selectedOptionalRiderList = [],
    onChange,
    onSearchRelationList,
    showModal,
  } = props;
  // 가상설계 여부
  const isVirtualPlan = $utils.checkPlanFlag(virtlPlanYn);
  // 실버널싱 특약 포함 여부
  const isSilverNursing = selectedOptionalRiderList.some(item =>
    checkOptionalRider(item, '실버널싱'),
  );
  // 자녀사랑맞춤지급특약 부가 여부
  const isDiv = selectedOptionalRiderList.some(item =>
    checkOptionalRider(item, '자녀사랑'),
  );
  // 사후정리특약 부가 여부
  const isFnb = selectedOptionalRiderList.some(item =>
    checkOptionalRider(item, '사후정리'),
  );
  // 계약자/피보험자가 동일한지 여부
  const isSameCustomer = customerList?.every(
    ({ policyRelatedPersonCode, custNo }) =>
      policyRelatedPersonCode === 'ALL' || custNo === customerList[0]?.custNo,
  );

  // hanjy: 설계목록에서 선택한건지 체크
  const { location } = useSelector(state => state.router);
  const [isPlanList, setIsPlanList] = useState(
    Boolean(location.state?.planEstablishNo),
  );

  const [ownerInfo, setOwnerInfo] = useState(null); // 계약자
  const [coveredPersonInfo, setCoveredPersonInfo] = useState(null); // 피보험자
  const [planCustomerList, setPlanCustomerList] = useState(null);
  const [deathBeneficiaryList, setDeathBeneficiaryList] = useState([]); // 사망시 수익자
  const [injuryBeneficiary, setInjuryBeneficiary] = useState(null); // 입원 상해시 수익자
  const [maturityBeneficiary, setMaturityBeneficiary] = useState(null); // 만기시 수익자
  const [designedDeputyPerson, setDesignedDeputyPerson] = useState([]); // 지정대리 청구인
  const [searchRelationVisible, setSearchRelationVisible] = useState(false);
  const [changeItem, setChangeItem] = useState({
    type: '',
    index: 0,
    excludeCustNo: [],
  });
  const [isShowDeputyPerson, setIsShowDeputyPerson] = useState(false);

  useEffect(() => {
    // 고객이 바뀌었을 경우 상세조회때 가져온 계약관계인 정보 초기화
    if (isPlanList) {
      if (planCustomerList) {
        if (planCustomerList.length !== customerList.length) {
          setIsPlanList(false);
        } else {
          for (let i = 0; i < planCustomerList.length; i++) {
            if (planCustomerList[i].custNo !== customerList[i].custNo) {
              setIsPlanList(false);
            }
          }
        }
      } else if (customerList.find(customer => customer.custNo)) {
        setPlanCustomerList(customerList);
      }
    }

    if (customerList.find(customer => customer.custNo)) {
      const [owner, coveredPerson] = customerList;

      if (ownerInfo || coveredPersonInfo) {
        if (
          (ownerInfo && ownerInfo.custNo !== owner.custNo) ||
          (coveredPersonInfo &&
            coveredPerson &&
            coveredPersonInfo.custNo !== coveredPerson.custNo)
        ) {
          setOwnerInfo(owner);
          setCoveredPersonInfo(coveredPerson || owner);

          if (!Object.values(beneficiaryInfo).includes(null)) {
            initBeneficiaryInfo(owner, coveredPerson || owner);
          } else {
            onChange([
              {
                relatedProspectCustomerNo: owner.custNo,
                policyRelatedPersonCode: 'Owner',
              },
              {
                relatedProspectCustomerNo: (coveredPerson || owner).custNo,
                policyRelatedPersonCode: 'CoveredPerson',
              },
            ]);
          }
        }
      } else {
        setOwnerInfo(owner);
        setCoveredPersonInfo(coveredPerson || owner);
        if (planEstablishRelatePerson.length === 0) {
          onChange([
            {
              relatedProspectCustomerNo: owner.custNo,
              policyRelatedPersonCode: 'Owner',
            },
            {
              relatedProspectCustomerNo: (coveredPerson || owner).custNo,
              policyRelatedPersonCode: 'CoveredPerson',
            },
          ]);
        }
      }
    }
  }, [customerList]);

  useEffect(() => {
    if (ownerInfo) {
      // 실버널싱 제도성 특약이 있는 경우
      if (isSilverNursing) {
        if (!isShowDeputyPerson) {
          if (!isVirtualPlan && isSameCustomer) {
            const deputyPersonList = Array(2).fill({
              relatedProspectCustomerNo: '',
              policyRelatedPersonCode: 'Beneficiary',
              policyRelatedPersonSubCode: '10050',
              beneficiaryShareRate: 0,
              relatedProspectCustomerName: '',
            });

            setDesignedDeputyPerson(deputyPersonList);
            onChange(planEstablishRelatePerson.concat(deputyPersonList));
            setIsShowDeputyPerson(true);
          }
        }
      }

      // 실버널싱 제도성 특약이 없는 경우
      else {
        if (isShowDeputyPerson) {
          if (
            planEstablishRelatePerson.filter(
              item =>
                ['10001', '10002'].includes(item.policyRelatedPersonSubCode) &&
                item.relatedProspectCustomerNo === ownerInfo.custNo,
            ).length === 0
          ) {
            setIsShowDeputyPerson(false);
            setDesignedDeputyPerson([]);
            onChange(
              planEstablishRelatePerson.filter(
                item => item.policyRelatedPersonSubCode !== '10050',
              ),
            );
          }
        }
      }
    }
  }, [selectedOptionalRiderList]);

  useEffect(() => {
    if (!Object.values(beneficiaryInfo).includes(null)) {
      if (ownerInfo) {
        const [owner, coveredPerson] = customerList;
        initBeneficiaryInfo(owner, coveredPerson || owner);
      } else if (isVirtualPlan) {
        initBeneficiaryInfo();
      } else {
        setBeneficiaryInfo(planEstablishRelatePerson);
      }
    }
  }, [virtlPlanYn, beneficiaryInfo]);

  const initBeneficiaryInfo = (owner = null, coveredPerson = null) => {
    let relationPersonList = [
      {
        relatedProspectCustomerNo: isVirtualPlan ? 0 : owner.custNo,
        policyRelatedPersonCode: 'Owner',
      },
      {
        relatedProspectCustomerNo: isVirtualPlan ? 0 : coveredPerson.custNo,
        policyRelatedPersonCode: 'CoveredPerson',
      },
    ];

    // hanjy: 설계목록에서 넘어왔을 경우 기존 계약관계인 데이터 반영
    // 사망시 수익자
    if (!beneficiaryInfo.isNotNeedDeathBeneficiary) {
      const planDeathBeneficiarys = isPlanList
        ? planEstablishRelatePerson.filter(
            item => item.policyRelatedPersonSubCode === '10000',
          )
        : [];
      const deathBeneficiarys =
        planDeathBeneficiarys.length === 0
          ? [
              {
                relatedProspectCustomerNo: 0,
                policyRelatedPersonCode: 'Beneficiary',
                policyRelatedPersonSubCode: '10000',
                beneficiaryShareRate: 100,
                relatedProspectCustomerName: '법정상속인',
                splitPayRateCd: '',
                splitPayEndAgeCd: '',
              },
            ].concat(
              Array(2).fill({
                relatedProspectCustomerNo: '',
                policyRelatedPersonCode: 'Beneficiary',
                policyRelatedPersonSubCode: '10000',
                beneficiaryShareRate: 0,
                relatedProspectCustomerName: '',
                splitPayRateCd: '',
                splitPayEndAgeCd: '',
              }),
            )
          : planDeathBeneficiarys.concat(
              Array(3 - planDeathBeneficiarys.length).fill({
                relatedProspectCustomerNo: '',
                policyRelatedPersonCode: 'Beneficiary',
                policyRelatedPersonSubCode: '10000',
                beneficiaryShareRate: 0,
                relatedProspectCustomerName: '',
                splitPayRateCd: '',
                splitPayEndAgeCd: '',
              }),
            );
      
      setDeathBeneficiaryList(deathBeneficiarys);
      relationPersonList = relationPersonList.concat(deathBeneficiarys);
    }

    // 입원 상해시 수익자
    if (beneficiaryInfo.isNeedInjuryBeneficiary) {
      const planInjuryBeneficiary =
        isPlanList &&
        planEstablishRelatePerson.find(
          item => item.policyRelatedPersonSubCode === '10001',
        );
      let injuryBeneficiary = {
        relatedProspectCustomerNo: isVirtualPlan ? 0 : coveredPerson.custNo,
        policyRelatedPersonCode: 'Beneficiary',
        policyRelatedPersonSubCode: '10001',
        beneficiaryShareRate: 100,
        relatedProspectCustomerName: isVirtualPlan
          ? '피보험자'
          : coveredPerson.name,
      };
      if (planInjuryBeneficiary) {
        injuryBeneficiary = { ...planInjuryBeneficiary };
      }
      setInjuryBeneficiary(injuryBeneficiary);
      relationPersonList = relationPersonList.concat(injuryBeneficiary);
    }

    // 만기시 수익자
    if (beneficiaryInfo.isNeedMaturityBeneficiary) {
      const planMaturityBeneficiary =
        isPlanList &&
        planEstablishRelatePerson.find(
          item => item.policyRelatedPersonSubCode === '10002',
        );
      let maturityBeneficiary = {
        relatedProspectCustomerNo: isVirtualPlan ? 0 : owner.custNo,
        policyRelatedPersonCode: 'Beneficiary',
        policyRelatedPersonSubCode: '10002',
        beneficiaryShareRate: 100,
        relatedProspectCustomerName: isVirtualPlan ? '계약자' : owner.name,
      };
      if (planMaturityBeneficiary) {
        maturityBeneficiary = { ...planMaturityBeneficiary };
      }
      setMaturityBeneficiary(maturityBeneficiary);
      relationPersonList = relationPersonList.concat(maturityBeneficiary);
    }

    // 지정대리청구인
    const isInsuredMyself = owner?.policyRelatedPersonCode === 'ALL';

    if (
      !isVirtualPlan &&
      (isSameCustomer || isInsuredMyself) &&
      (relationPersonList.filter(
        item =>
          ['10001', '10002'].includes(item.policyRelatedPersonSubCode) &&
          item.relatedProspectCustomerNo === owner.custNo,
      ).length > 0 ||
        isSilverNursing)
    ) {
      const planDeputyPersonList = isPlanList
        ? planEstablishRelatePerson.filter(
            item => item.policyRelatedPersonSubCode === '10050',
          )
        : [];
      const deputyPersonList = planDeputyPersonList.concat(
        Array(2 - planDeputyPersonList.length).fill({
          relatedProspectCustomerNo: '',
          policyRelatedPersonCode: 'Beneficiary',
          policyRelatedPersonSubCode: '10050',
          beneficiaryShareRate: 0,
          relatedProspectCustomerName: '',
        }),
      );

      setDesignedDeputyPerson(deputyPersonList);
      relationPersonList = relationPersonList.concat(deputyPersonList);
      setIsShowDeputyPerson(true);
    } else {
      setIsShowDeputyPerson(false);
    }

    onChange(relationPersonList);
  };

  const setBeneficiaryInfo = list => {
    if (!beneficiaryInfo.isNotNeedDeathBeneficiary) {
      let deathBeneficiarys = list.filter(
        item => item.policyRelatedPersonSubCode === '10000',
      );
      if (deathBeneficiarys.length < 3) {
        deathBeneficiarys = deathBeneficiarys.concat(
          Array(3 - deathBeneficiarys.length).fill({
            relatedProspectCustomerNo: '',
            policyRelatedPersonCode: 'Beneficiary',
            policyRelatedPersonSubCode: '10000',
            beneficiaryShareRate: 0,
            relatedProspectCustomerName: '',
          }),
        );
      }

      setDeathBeneficiaryList(deathBeneficiarys);
    }

    if (beneficiaryInfo.isNeedInjuryBeneficiary) {
      setInjuryBeneficiary(
        list.find(item => item.policyRelatedPersonSubCode === '10001'),
      );
    }

    if (beneficiaryInfo.isNeedMaturityBeneficiary) {
      setMaturityBeneficiary(
        list.find(item => item.policyRelatedPersonSubCode === '10002'),
      );
    }

    const [owner] = customerList.filter(customer =>
      ['ALL', 'Owner'].includes(customer.policyRelatedPersonCode),
    );

    if (
      !isVirtualPlan &&
      owner.policyRelatedPersonCode === 'ALL' &&
      (list.filter(
        item =>
          ['10001', '10002'].includes(item.policyRelatedPersonSubCode) &&
          item.relatedProspectCustomerNo === owner.custNo,
      ).length > 0 ||
        isSilverNursing)
    ) {
      let deputyPersonList = list.filter(
        item => item.policyRelatedPersonSubCode === '10050',
      );
      if (deputyPersonList.length < 2) {
        deputyPersonList = deputyPersonList.concat(
          Array(2 - deputyPersonList.length).fill({
            relatedProspectCustomerNo: '',
            policyRelatedPersonCode: 'Beneficiary',
            policyRelatedPersonSubCode: '10050',
            beneficiaryShareRate: 0,
            relatedProspectCustomerName: '',
          }),
        );
      }

      setDesignedDeputyPerson(deputyPersonList);
      setIsShowDeputyPerson(true);
    }
  };

  const handleSearchRelationList = (type = '', index = 0) => {
    const [ownerInfo] = customerList.filter(customer =>
      ['ALL', 'Owner'].includes(customer.policyRelatedPersonCode),
    );

    onSearchRelationList(
      ownerInfo.custNo,
      ownerInfo.custKind,
      type === 'deputy',
    );
    setSearchRelationVisible(true);

    let excludeCustNoArray = [];
    if (type === 'death') {
      excludeCustNoArray = customerList
        .filter(customer =>
          ['ALL', 'CoveredPerson'].includes(customer.policyRelatedPersonCode),
        )
        .map(item => item.custNo);
    } else if (type === 'deputy') {
      excludeCustNoArray = customerList.map(item => item.custNo);
    }
    setChangeItem({ type, index, excludeCustNo: excludeCustNoArray });
  };

  const handleChangeRelation = ({ custNo, name, adult = true }) => {
    if (changeItem.type === 'death') {
      if (
        deathBeneficiaryList
          .filter((item, index) => index !== changeItem.index)
          .find(item => item.relatedProspectCustomerNo === custNo)
      ) {
        showModal({ visible: true, msg: '동일한 수익자가 존재합니다.' });
      } else {
        const list = deathBeneficiaryList.map((item, index) => {
          return index === changeItem.index
            ? {
                ...item,
                relatedProspectCustomerNo: custNo,
                relatedProspectCustomerName: name,
                splitPayRateCd: adult ? '' : item.splitPayRateCd,
                splitPayEndAgeCd: adult ? '' : item.splitPayEndAgeCd,
                adult,
              }
            : item;
        }); 

        setDeathBeneficiaryList(list);
        onChange(
          planEstablishRelatePerson
            .filter(item => item.policyRelatedPersonSubCode !== '10000')
            .concat(list),
        );
      }
    } else if (changeItem.type === 'maturity') {
      setMaturityBeneficiary({
        relatedProspectCustomerName: name,
        relatedProspectCustomerNo: custNo,
      });

      let list = planEstablishRelatePerson.map(item => {
        return item.policyRelatedPersonSubCode === '10002'
          ? {
              ...item,
              relatedProspectCustomerNo: custNo,
              relatedProspectCustomerName: name,
            }
          : item;
      });

      if (
        !isVirtualPlan &&
        isSameCustomer &&
        (planEstablishRelatePerson.find(
          item =>
            item.policyRelatedPersonSubCode === '10001' &&
            item.relatedProspectCustomerNo === ownerInfo.custNo,
        ) ||
          custNo === ownerInfo.custNo ||
          isSilverNursing)
      ) {
        if (
          !planEstablishRelatePerson.find(
            item => item.policyRelatedPersonSubCode === '10050',
          )
        ) {
          const array = Array(2).fill({
            relatedProspectCustomerNo: '',
            policyRelatedPersonCode: 'Beneficiary',
            policyRelatedPersonSubCode: '10050',
            beneficiaryShareRate: 0,
            relatedProspectCustomerName: '',
          });
          list = list.concat(array);
          setDesignedDeputyPerson(array);

          setIsShowDeputyPerson(true);
        }
      } else {
        list = list.filter(item => item.policyRelatedPersonSubCode !== '10050');
        setDesignedDeputyPerson([]);
        setIsShowDeputyPerson(false);
      }
      onChange(list);
    } else if (changeItem.type === 'injury') {
      setInjuryBeneficiary({
        relatedProspectCustomerName: name,
        relatedProspectCustomerNo: custNo,
      });

      let list = planEstablishRelatePerson.map(item => {
        return item.policyRelatedPersonSubCode === '10001'
          ? {
              ...item,
              relatedProspectCustomerNo: custNo,
              relatedProspectCustomerName: name,
            }
          : item;
      });

      if (
        !isVirtualPlan &&
        isSameCustomer &&
        (planEstablishRelatePerson.find(
          item =>
            item.policyRelatedPersonSubCode === '10002' &&
            item.relatedProspectCustomerNo === ownerInfo.custNo,
        ) ||
          custNo === ownerInfo.custNo ||
          isSilverNursing)
      ) {
        if (
          !planEstablishRelatePerson.find(
            item => item.policyRelatedPersonSubCode === '10050',
          )
        ) {
          const array = Array(2).fill({
            relatedProspectCustomerNo: '',
            policyRelatedPersonCode: 'Beneficiary',
            policyRelatedPersonSubCode: '10050',
            beneficiaryShareRate: 0,
            relatedProspectCustomerName: '',
          });
          list = list.concat(array);
          setDesignedDeputyPerson(array);
          setIsShowDeputyPerson(true);
        }
      } else {
        list = list.filter(item => item.policyRelatedPersonSubCode !== '10050');
        setDesignedDeputyPerson([]);
        setIsShowDeputyPerson(false);
      }
      onChange(list);
    } else if (changeItem.type === 'deputy') {
      if (
        designedDeputyPerson
          .filter((item, index) => index !== changeItem.index)
          .find(item => item.relatedProspectCustomerNo === custNo)
      ) {
        showModal({
          visible: true,
          msg: '동일한 지정대리 청구인이 존재합니다.',
        });
      } else {
        const list = designedDeputyPerson.map((item, index) => {
          return index === changeItem.index
            ? {
                ...item,
                relatedProspectCustomerNo: custNo,
                relatedProspectCustomerName: name,
              }
            : item;
        });

        onChange(
          planEstablishRelatePerson
            .filter(item => item.policyRelatedPersonSubCode !== '10050')
            .concat(list),
        );
        setDesignedDeputyPerson(list);
      }
    }

    setSearchRelationVisible(false);
    setChangeItem({ type: '', index: 0, excludeCustNo: [] });
  };

  const handleChangeShareRate = (value, idx) => {
    const list = deathBeneficiaryList.map((item, index) => {
      return index === idx
        ? { ...item, beneficiaryShareRate: value === '' ? 0 : Number(value) }
        : item;
    });

    setDeathBeneficiaryList(list);
    onChange(
      planEstablishRelatePerson
        .filter(item => item.policyRelatedPersonSubCode !== '10000')
        .concat(list),
    );
  };

  const handleDeleteBeneficiary = (type, index) => {
    if (type === 'death') {
      let list = [];
      if (index === 0) {
        if (deathBeneficiaryList[index].relatedProspectCustomerNo !== 0) {
          list = deathBeneficiaryList.map((item, idx) => {
            return index === idx
              ? {
                  ...item,
                  relatedProspectCustomerNo: 0,
                  relatedProspectCustomerName: '법정상속인',
                  beneficiaryShareRate: 100,
                  splitPayRateCd: '',
                  splitPayEndAgeCd: '',
                }
              : item;
          });
        } 
      } else {
        list = deathBeneficiaryList.map((item, idx) => {
          return index === idx
            ? {
                ...item,
                relatedProspectCustomerNo: '',
                relatedProspectCustomerName: '',
                beneficiaryShareRate: 0,
                splitPayRateCd: '',
                splitPayEndAgeCd: '',
              }
            : item;
        });
      }

      if(isFnb) {
        list = deathBeneficiaryList.map((item, idx) => {
          return index === idx
            ? {
                ...item,
                relatedProspectCustomerNo: '',
                relatedProspectCustomerName: '',
                beneficiaryShareRate: 0,
                splitPayRateCd: '',
                splitPayEndAgeCd: '',
              }
            : item;
        });
      }

      setDeathBeneficiaryList(list);

      onChange(
        planEstablishRelatePerson
          .filter(item => item.policyRelatedPersonSubCode !== '10000')
          .concat(list),
      );
    } else if (type === 'maturity') {
      setMaturityBeneficiary({
        relatedProspectCustomerNo: ownerInfo.custNo,
        relatedProspectCustomerName: ownerInfo.name,
      });

      let list = planEstablishRelatePerson.map(item => {
        return item.policyRelatedPersonSubCode === '10002'
          ? {
              ...item,
              relatedProspectCustomerNo: ownerInfo.custNo,
              relatedProspectCustomerName: ownerInfo.name,
            }
          : item;
      });

      if (!isShowDeputyPerson && isSameCustomer) {
        const deputyPersonList = Array(2).fill({
          relatedProspectCustomerNo: '',
          policyRelatedPersonCode: 'Beneficiary',
          policyRelatedPersonSubCode: '10050',
          beneficiaryShareRate: 0,
          relatedProspectCustomerName: '',
        });

        setDesignedDeputyPerson(deputyPersonList);
        list = list.concat(deputyPersonList);

        setIsShowDeputyPerson(true);
      }

      onChange(list);
    } else if (type === 'injury') {
      setInjuryBeneficiary({
        relatedProspectCustomerNo: coveredPersonInfo.custNo,
        relatedProspectCustomerName: coveredPersonInfo.name,
      });

      let list = planEstablishRelatePerson.map(item => {
        return item.policyRelatedPersonSubCode === '10001'
          ? {
              ...item,
              relatedProspectCustomerNo: coveredPersonInfo.custNo,
              relatedProspectCustomerName: coveredPersonInfo.name,
            }
          : item;
      });

      if (
        !isShowDeputyPerson &&
        coveredPersonInfo.policyRelatedPersonCode === 'ALL'
      ) {
        const deputyPersonList = Array(2).fill({
          relatedProspectCustomerNo: '',
          policyRelatedPersonCode: 'Beneficiary',
          policyRelatedPersonSubCode: '10050',
          beneficiaryShareRate: 0,
          relatedProspectCustomerName: '',
        });

        setDesignedDeputyPerson(deputyPersonList);
        list = list.concat(deputyPersonList);

        setIsShowDeputyPerson(true);
      }

      onChange(list);
    } else if (type === 'deputy') {
      const [first, second] = designedDeputyPerson;
      let list = [].concat(index === 0 ? second : first).concat({
        relatedProspectCustomerNo: '',
        policyRelatedPersonCode: 'Beneficiary',
        policyRelatedPersonSubCode: '10050',
        beneficiaryShareRate: 0,
        relatedProspectCustomerName: '',
      });

      setDesignedDeputyPerson(list);
      onChange(
        planEstablishRelatePerson
          .filter(item => item.policyRelatedPersonSubCode !== '10050')
          .concat(list),
      );
    }
  };

  const handleChangeSplitPayInfo = (data, idx) => {
    const list = deathBeneficiaryList.map((item, index) => {
      return index === idx ? { ...item, ...data } : item;
    });

    setDeathBeneficiaryList(list);
    onChange(
      planEstablishRelatePerson
        .filter(item => item.policyRelatedPersonSubCode !== '10000')
        .concat(list),
    );
  };

  return (
    <React.Fragment>
      <div className="tit-area">
        <h2>계약관계인</h2>
      </div>
      {!Object.values(beneficiaryInfo).includes(null) && (
        <>
          <div className="wrap-contractor">
            {!beneficiaryInfo.isNotNeedDeathBeneficiary && (
              <DeathBeneficiary
                virtlPlanYn={virtlPlanYn}
                deathBeneficiaryList={deathBeneficiaryList}
                handleSearchRelationList={handleSearchRelationList}
                handleChangeShareRate={handleChangeShareRate}
                handleDeleteBeneficiary={handleDeleteBeneficiary}
                handleChangeSplitPayInfo={handleChangeSplitPayInfo}
                isDiv={isDiv}
                isFnb={isFnb}
              />
            )}

            {beneficiaryInfo.isNeedMaturityBeneficiary && (
              <MaturityBeneficiary
                maturityBeneficiary={maturityBeneficiary}
                virtlPlanYn={virtlPlanYn}
                handleSearchRelationList={handleSearchRelationList}
                customerList={customerList}
                handleDeleteBeneficiary={handleDeleteBeneficiary}
              />
            )}

            {beneficiaryInfo.isNeedInjuryBeneficiary && (
              <InjuryBeneficiary
                injuryBeneficiary={injuryBeneficiary}
                virtlPlanYn={virtlPlanYn}
                handleSearchRelationList={handleSearchRelationList}
                customerList={customerList}
                handleDeleteBeneficiary={handleDeleteBeneficiary}
              />
            )}

            {isShowDeputyPerson &&
              !(
                !beneficiaryInfo.isNotNeedDeathBeneficiary &&
                beneficiaryInfo.isNeedMaturityBeneficiary &&
                beneficiaryInfo.isNeedInjuryBeneficiary
              ) && (
                <DesignedDeputyPerson
                  designedDeputyPerson={designedDeputyPerson}
                  handleSearchRelationList={handleSearchRelationList}
                  handleDeleteBeneficiary={handleDeleteBeneficiary}
                />
              )}
          </div>

          {isShowDeputyPerson &&
            !beneficiaryInfo.isNotNeedDeathBeneficiary &&
            beneficiaryInfo.isNeedMaturityBeneficiary &&
            beneficiaryInfo.isNeedInjuryBeneficiary && (
              <div className="wrap-contractor">
                <DesignedDeputyPerson
                  designedDeputyPerson={designedDeputyPerson}
                  handleSearchRelationList={handleSearchRelationList}
                  handleDeleteBeneficiary={handleDeleteBeneficiary}
                />
              </div>
            )}
        </>
      )}

      {Object.values(beneficiaryInfo).includes(null) && (
        <table className="tbl-sty1 main-contract">
          <tbody>
            <tr>
              <td colSpan="4" className="nodata">
                주계약 선택 후 계약관계인 선택하실 수 있습니다.
              </td>
            </tr>
          </tbody>
        </table>
      )}

      <SatModal
        visible={searchRelationVisible}
        setVisible={() => {
          setSearchRelationVisible(false);
          setChangeItem({ type: '', index: 0, excludeCustNo: [] });
        }}
        wide
      >
        <SearchCustomer
          title={'계약관계인 검색'}
          onSelectCustomer={handleChangeRelation}
          isRelation
          excludeCustNo={changeItem.excludeCustNo}
          isAdult={changeItem.type === 'deputy'}
          isDefaultRelation={true}
        />
      </SatModal>
    </React.Fragment>
  );
};

export default React.memo(ContractRelatePerson);
